import { useEffect, useState } from "react";
import { Button, Tabs } from "react-bootstrap";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import Chat from "./chatcomponent/Chat";
import CollabAI from "./CollabAI";
import CollabBrief from "./CollabBrief";
import CollabCredits from "./CollabCredits";
import CollabDocuments from "./CollabDocuments";
import CollaborationChecklist from "./CollaborationChecklist";
import CollabReport from "./CollabReport";
import Contributors from "./Contributors";

const CollabObject = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get tab from query string ?tab=overview
  const queryParams = new URLSearchParams(location.search);
  const initialTab = queryParams.get("tab") || "brief";
  const collabUniqueId = queryParams.get("collabUniqueId");
  const collaborationName = queryParams.get("collaborationName");

  // Numeric id passed via router state or query parameter (as fallback)
  const collabId = location.state?.collabId || queryParams.get("collabId");

  const [activeTab, setActiveTab] = useState(initialTab);

  const handleTabSelect = (key) => {
    setActiveTab(key);
    // Preserving all existing query parameters and state
    const params = new URLSearchParams(location.search);
    params.set("tab", key);
    navigate(
      `${location.pathname}?${params.toString()}`,
      { replace: true, state: { ...location.state, collabId } },
    );
  };

  useEffect(() => {
    // If URL changes manually, update activeTab
    const tab = new URLSearchParams(location.search).get("tab");
    if (tab && tab !== activeTab) setActiveTab(tab);
  }, [location.search, activeTab]);

  const handleBack = () => {
    navigate(-1);
  };
  return (
    <div className="scrollable-container" style={{ height: "100%" }}>
      <div className="header-container">
        <h1>
          <strong>
            Collab Object - {collaborationName} ({collabUniqueId})
          </strong>
        </h1>
        <Button onClick={handleBack} variant="info" className="tooltip-btn">
          <IoArrowBackCircleSharp />
          <span className="tooltip-text">Go to Back</span>
        </Button>
      </div>

      <Tabs activeKey={activeTab} onSelect={handleTabSelect} mountOnEnter>
        <Tabs.Tab eventKey="brief" title="Brief">
          <CollabBrief
            collabId={collabId}
            collaborationName={collaborationName}
          />
        </Tabs.Tab>
        <Tabs.Tab eventKey="contributors" title="Contributors">
          <Contributors
            collabId={collabId}
            collaborationName={collaborationName}
          />
        </Tabs.Tab>

        <Tabs.Tab eventKey="chat" title="Chat">
          <Chat collabId={collabId} collaborationName={collaborationName} />
        </Tabs.Tab>
        <Tabs.Tab eventKey="documents" title="Documents">
          <CollabDocuments
            collabId={collabId}
            collaborationName={collaborationName}
          />
        </Tabs.Tab>
        <Tabs.Tab eventKey="checklist" title="Checklist">
          <CollaborationChecklist
            collabId={collabId}
            collaborationName={collaborationName}
          />
        </Tabs.Tab>
        <Tabs.Tab eventKey="credits" title="Credits & Data">
          <CollabCredits
            collabId={collabId}
            collaborationName={collaborationName}
          />
        </Tabs.Tab>
        <Tabs.Tab eventKey="audit" title="Audit Report">
          <CollabReport
            collabId={collabId}
            collaborationName={collaborationName}
          />
        </Tabs.Tab>
         <Tabs.Tab eventKey="collabAi" title="CollabAI">
          <CollabAI
            collabId={collabId}
            collaborationName={collaborationName}
          />
        </Tabs.Tab>
      </Tabs>
    </div>
  );
};

export default CollabObject;